import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import SectionDetail from '../../components/section/SectionDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { createSection } from '../../redux/section/section_actions';

class SectionCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.sectionDetail = undefined;
  }

  onSaveHandler() {
    const newSection = this.sectionDetail.getWrappedInstance().getWrappedInstance().getSectionData();
    this.props.createSection(newSection);
  }

  render() {
    const { isCreating, errorMessage, createSection, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create section')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SectionDetail
            ref={ref => (this.sectionDetail = ref)}
            building={building}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="section-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.section.errorMessage,
  isCreating: state.section.isCreating,
});

const mapDispatchToProps = (dispatch, props) => ({
  createSection: section =>
    defaultRejectHandler(
      dispatch(
        createSection(
          section.name,
          section.envelop_id,
          section.description || '',
          props.building.id,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SectionCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/section/SectionCreateModal.js